import { createSlice } from "@reduxjs/toolkit";
import {
  getSchoolProfileDetails,
  getSchoolObservations,
  AddNoteToStudent,
} from "../actions/school.actions";
const initialState = {
  schoolProfileDetails: {
    loading: false,
    error: null as unknown | null,
    data: [] as any,
  },
  observations: {
    loading: false,
    error: null as unknown | null,
    data: [] as any,
  },
  addNoteToStudent: {
    loading: false,
    error: null as unknown | null,
    data: {} as any,
  },
  loading: false,
  error: null as unknown | null,
};

export const schoolSlice = createSlice({
  name: "school",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSchoolProfileDetails.pending, (state) => {
      state.schoolProfileDetails.loading = true;
    });
    builder.addCase(getSchoolProfileDetails.fulfilled, (state, action) => {
      state.schoolProfileDetails.data = action.payload;
      state.schoolProfileDetails.loading = false;
    });
    builder.addCase(getSchoolProfileDetails.rejected, (state, action) => {
      state.schoolProfileDetails.data = [];
      state.schoolProfileDetails.loading = false;
      state.error = action.payload;
    });

    // Notes
    builder.addCase(getSchoolObservations.pending, (state) => {
      state.observations.loading = true;
    });
    builder.addCase(getSchoolObservations.fulfilled, (state, action) => {
      state.observations.data = action.payload;
      state.observations.loading = false;
    });
    builder.addCase(getSchoolObservations.rejected, (state, action) => {
      state.observations.data = [];
      state.observations.loading = false;
      state.error = action.payload;
    });
    // to add note
    builder.addCase(AddNoteToStudent.pending, (state) => {
      state.addNoteToStudent.loading = true;
    });
    builder.addCase(AddNoteToStudent.fulfilled, (state, action) => {
      state.addNoteToStudent.data = action.payload;
      state.addNoteToStudent.loading = false;
    });
    builder.addCase(AddNoteToStudent.rejected, (state, action) => {
      state.addNoteToStudent.data = {};
      state.addNoteToStudent.loading = false;
      state.error = action.payload;
    });
  },
});
export default schoolSlice.reducer;
